/* NOMI v23.34: site-wide motion layer (pairs with nomi-motion.css).
   Adds scroll reveals to pages that don't already run their own motion engine
   (the homepage .nx/.nh engine and the inner-page .ni engine are left alone).
   Nothing is hidden unless this script runs, and nothing runs under prefers-reduced-motion. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = [
    '.npg__hero>*', '.npg__wrap>h2', '.npg__wrap>.npg__sub', '.npg__card', '.npg__note', '.npg__strip>*', '.npg__narrow>*',
    '.nomi-faq details', '.nx-review-card', '.nx-benefit-card', '.na-gcard', '.na-card', '.nc-card', '.rv-card',
    '.product-card', '.nj-card', '.nomi-updates', '.nomi-shared-footer-top', '.nomi-shared-footer-links'
  ].join(',');
  var SKIP = '.nx, .nh, .ni, .nn, [data-no-motion]';
  function init() {
    var els = Array.prototype.filter.call(document.querySelectorAll(SEL), function (el) {
      return !el.closest(SKIP) && !el.classList.contains('nx-reveal');
    });
    if (!els.length) return;
    document.documentElement.classList.add('nm-js');
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) return; // already on screen: leave it alone
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--nm-d', Math.min(i, 6) * 0.07 + 's');
      el.classList.add('nm-r');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('nm-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { if (el.classList.contains('nm-r')) io.observe(el); });
    // safety net: anything still hidden after 4s (e.g. inside a closed tab) is shown
    setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.nm-r:not(.nm-in)'), function (el) {
        var r = el.getBoundingClientRect();
        if (r.width === 0 && r.height === 0) el.classList.add('nm-in');
      });
    }, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* v23.41: "View cup" badge follows the cursor over the home cup cards (nomi-home.css .nh-type-dot). */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function bind() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nh-type]'), function (card) {
      var art = card.querySelector('.nh-card-art, .ni-product-art');
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--dx', (ev.clientX - r.left) + 'px');
        card.style.setProperty('--dy', (ev.clientY - r.top) + 'px');
        card.classList.toggle('is-dot', !!(art && art.contains(ev.target)));
      });
      card.addEventListener('pointerleave', function () { card.classList.remove('is-dot'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();

/* v23.65: on touch screens there is no hover, so the cup card nearest the middle of the screen gets .is-live
   (the CSS mirrors the hover look). One card at a time; nothing under reduced motion. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover:none),(pointer:coarse)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-nh-type]'));
  if (!cards.length || !('IntersectionObserver' in window)) return;
  var live = null, ticking = false;
  function pick() {
    ticking = false;
    var mid = window.innerHeight / 2, best = null, bd = Infinity;
    cards.forEach(function (c) {
      var r = c.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var d = Math.abs((r.top + r.bottom) / 2 - mid);
      if (d < bd) { bd = d; best = c; }
    });
    if (best && bd > window.innerHeight * 0.45) best = null;
    if (best !== live) { if (live) live.classList.remove('is-live'); live = best; if (live) live.classList.add('is-live'); }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(pick); } }
  var io = new IntersectionObserver(function () { onScroll(); }, { threshold: [0, .25, .5, .75, 1] });
  cards.forEach(function (c) { io.observe(c); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  pick();
})();
